import React, { useState, useEffect } from 'react';
import { cn } from '../../lib/utils';

const StaggeredAnimation = ({ 
  children, 
  className, 
  delay = 100, 
  stagger = 50,
  animation = 'fadeUp'
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const getAnimationClasses = () => {
    switch (animation) {
      case 'fadeUp':
        return isVisible 
          ? "opacity-100 translate-y-0" 
          : "opacity-0 translate-y-4";
      case 'fadeLeft':
        return isVisible 
          ? "opacity-100 translate-x-0" 
          : "opacity-0 -translate-x-4";
      case 'fadeRight':
        return isVisible 
          ? "opacity-100 translate-x-0" 
          : "opacity-0 translate-x-4";
      case 'scale':
        return isVisible 
          ? "opacity-100 scale-100" 
          : "opacity-0 scale-95";
      default:
        return isVisible 
          ? "opacity-100 translate-y-0" 
          : "opacity-0 translate-y-4";
    }
  };

  return (
    <div
      className={cn(
        "transition-all duration-500 ease-out",
        getAnimationClasses(),
        className
      )}
      style={{
        transitionDelay: `${stagger}ms`
      }}
    >
      {children}
    </div>
  );
};

export default StaggeredAnimation;
